import { FullPageLogoLoader } from './FullPageLogoLoader'

export const RouteLoading = () => <FullPageLogoLoader />
